var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imageSource
    ? _c("img", {
        attrs: {
          src: "data:imagejpeg;base64," + this.imageSource,
          alt: _vm.altText
        }
      })
    : _c("v-icon", [_vm._v("fas fa-user")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }